import { useEffect, useState } from "react";
import { fetchQuote } from "@/lib/api";

/**
 * The backend is the single source of truth for product price, shipping and
 * total. The frontend never computes payable amounts itself.
 */
export const useQuote = ({ productCode, quantity, country, state }) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!productCode || !quantity) {
      setQuote(null);
      return;
    }
    let alive = true;
    setLoading(true);
    fetchQuote({
      product_code: productCode,
      quantity,
      country: country || "Malaysia",
      state: state || null,
    })
      .then((data) => alive && setQuote(data))
      .catch(() => alive && setQuote(null))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, [productCode, quantity, country, state]);

  return { quote, loading };
};
